import { each } from 'lodash';
import {
  REQUEST_OPPORTUNITY_OWNER_SIGNATURE,
  REQUEST_EMAIL_SIGNATURE,
  REQUEST_EMAIL_SIGNATURES,
} from './actions';

const initialState = {
  ownerSignatures: {
  }, // indexed by clientId, initiativeId, opportunityId, collectorId
  signatures: {
  }, // indexed by email
};

const getKey = (clientId, initiativeId, id, collectorId) => `${clientId}::${initiativeId}::${id}::${collectorId}`;

const EmailSignatureReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_OPPORTUNITY_OWNER_SIGNATURE: {
      const {
        clientId, initiativeId, collectorId, id, status, signature, isOwner, isMyEmailConfirm, owners,
        collectors, auth, dynamicSenders,
      } = action;
      const k = getKey(clientId, initiativeId, id, collectorId);
      const { ownerSignatures } = state;
      return {
        ...state,
        ownerSignatures: {
          ...ownerSignatures,
          [k]: {
            status,
            signature,
            isOwner,
            owners,
            collectors,
            auth,
            isMyEmailConfirm,
            dynamicSenders,
          },
        },
      };
    }
    case REQUEST_EMAIL_SIGNATURE: {
      const {
        email, status, signature,
      } = action;
      const { signatures } = state;
      return {
        ...state,
        signatures: {
          ...signatures,
          [email]: { status, signature },
        },
      };
    }
    case REQUEST_EMAIL_SIGNATURES: {
      const {
        signatures,
      } = action;
      const newSignatures = { ...state.signatures };
      each(signatures, (signature) => {
        newSignatures[signature.email] = {
          status: signature.status,
          signature: signature.signature,
        };
      });
      return {
        ...state,
        signatures: newSignatures,
      };
    }
    default:
      return state;
  }
};

export const getOpportunityOwnerSignature = (state, clientId, initiativeId, id, collectorId) => {
  const k = getKey(clientId, initiativeId, id, collectorId);
  return state.emailSignatures.ownerSignatures[k] || {};
};
export const getEmailSignature = (state, email) => state.emailSignatures.signatures[email] || {};
export const getEmailSignatures = state => state.emailSignatures.signatures || {};

// Export Reducer
export default EmailSignatureReducer;
